import type { CodeModule } from '../types/code.types'

/** Empty registry — demo modules (e.g. CommonUtils) are not merged into base configuration. */
const mockCodeModules: Record<string, CodeModule> = {}

export function getMockModule(id: string): CodeModule | null {
  return mockCodeModules[id] ?? mockCodeModules[`module-${id}`] ?? null
}

export function getAllMockModuleIds(): string[] {
  return Object.keys(mockCodeModules)
}
